module.exports = __webpack_public_path__ + "img/document-update.d1a72652.svg";